<script setup lang="ts">
import { api } from '@/api';
import type { TimeZoneInfoDto } from '@/api/generator';
import VeeAutocomplete from '@/components/forms/Autocomplete/VeeAutocomplete.vue';
import VeeSelect from '@/components/forms/Select/VeeSelect.vue';
import { useSystemStore } from '@/stores/systemStore';
import { computed, onMounted, ref } from 'vue';

interface ChangeLanguageFormProps {
  loading?: boolean;
}

defineProps<ChangeLanguageFormProps>();

const emits = defineEmits<{
  update: [];
}>();

const timezones = ref<TimeZoneInfoDto[]>([]);

onMounted(async () => {
  const { result: timezonesResult } = await api.localizationApi.getTimesZones();
  if (timezonesResult) {
    timezones.value = timezonesResult;
  }
});

const languageOptions = computed(() => {
  return useSystemStore().languages?.map((item) => {
    return {
      title: item.displayName,
      value: item.name,
    };
  });
});

const timezoneOptions = computed(() => {
  return timezones.value.map((item) => {
    return {
      title: item.displayName,
      value: item.id,
    };
  });
});
</script>

<template>
  <p class="text-h5 mb-6">
    {{ $t('LanguageAndTimezone') }}
  </p>
  <form>
    <VeeSelect
      :label="$t('Language')"
      name="language"
      :items="languageOptions"
      @update:modelValue="emits('update')"
    />
    <VeeAutocomplete
      :label="$t('Timezone')"
      name="timezone"
      :items="timezoneOptions"
      class="mt-6"
      emptyAsUndefined
      @update:modelValue="emits('update')"
    />
  </form>
</template>

<style lang="scss" scoped>
.language-select {
  max-width: 50%;
}
</style>
